import React from 'react'
import PropTypes from 'prop-types'
import Immutable from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import DialogContent from '@material-ui/core/DialogContent'
import { connect } from 'react-redux'

import AppointementList from '../../list/AppointmentsList'
import Dialog from '../index'
import PatientForm from '../../form/patient'
import * as patientSelectors from '../../../redux/patients/selectors'
import * as appointmentActions from '../../../redux/appointments/actions'
import * as appointmentSelectors from '../../../redux/appointments/selectors'
import * as treatmentActions from '../../../redux/treatments/actions'
import * as treatmentSelectors from '../../../redux/treatments/selectors'
import * as patientActions from '../../../redux/patients/actions'
import * as insuranceCompanySelectors from '../../../redux/insuranceCompanies/selectors'
import * as dialogSelectors from '../../../redux/dialogs/selectors'
import './patientDialog.scss'
import TreatmentsList from '../../list/TreatmentsList'
import CopaidSessionsSection from '../../form/patient/CopaidSessionsSection'
import BorderedArea from '../../layout/BorderedArea'
import { patientRequiresCopay } from '../../../utils/copaySessions'
import { appendCopaidSession, removeCopaidSession } from '../../../utils/copaidSessionHandlers'

const PatientDialog = ({
  handleCloseDialog, isDialogOpened, patient, insuranceCompanies, patientAppointments, dispatchGetAppointmentsByPatient, dipatchGetTreatmentsByPatient, patientTreatments, dispatchUpdatePatient, dispatchAddPatient, dispatchRemovePatient, dispatchRefreshPatient,
}) => {
  const [dataLoaded, setDataLoaded] = React.useState({})

  React.useEffect(() => {
    if(isDialogOpened) {
      // Only load data if its an existing patient and hasnt been loaded before
      // patient will be null if this is a new patient being created.
      if(patient && !dataLoaded[patient.get('_id')]) {
        // data is not loaded yet for selected patient

        setDataLoaded({ [patient.get('_id')]: true })

        dispatchRefreshPatient(patient.get('_id'))
        dipatchGetTreatmentsByPatient(patient.get('_id'))
        dispatchGetAppointmentsByPatient(patient.get('_id'))
      }
    }
  }, [isDialogOpened])

  const handleSubmit = (fields) => {
    if(!fields) return null

    let patient = {
      name: fields.name,
      lastName: fields.lastName,
      dni: fields.dni,
      telephone: fields.telephone,
      address: fields.address,
      birthDate: fields.birthDate,
      insuranceCompany: fields.insuranceCompany,
      doctor: fields.doctor,
      insuranceNumber: fields.insuranceNumber,
    }

    if(fields._id) {
      patient = {
        _id: fields._id,
        ...patient,
      }
      return dispatchUpdatePatient(patient)
    }
    return dispatchAddPatient(patient)
  }

  const handleRemove = (id) => {
    if(!id) {
      alert('Id is null')
    }
    return dispatchRemovePatient(id)
  }

  const handleAddCopaidSession = ({ amount, date }) => {
    if (!patient || !patient.has('_id')) return null
    return dispatchUpdatePatient(appendCopaidSession(patient, { amount, date }))
  }

  const handleDeleteCopaidSession = (sessionId) => {
    const answer = window.confirm('Estas seguro que quieres borrar este copago?')
    if (answer !== true || !patient) return null
    return dispatchUpdatePatient(removeCopaidSession(patient, sessionId))
  }

  return (
    <Dialog
      onClose={handleCloseDialog}
      maxWidth='md'
      open={isDialogOpened}
      labelBy='new-patient'
      title='Paciente'
    >
      <DialogContent dividers>
        {/* When patients are removed, we set the removed field to true and filter them on the get all api call */}
        {/* on the getById the deleted patients will be returned, thats why here we show a message if we are showing a previously removed patient */}
        {patient && patient.get('removed') ? <small className='small-red'>Este paciente ha sido eliminado.</small> : null}

        <PatientForm
          handleSubmit={handleSubmit}
          handleRemove={handleRemove}
          closeDialog={handleCloseDialog}
          currentPatient={patient}
          defaultFields={patient ? {
            ...patient.toJS(),
            insuranceCompany: patient.getIn(['insuranceCompany', '_id']) || patient.get('insuranceCompany') || '',
          } : null}
        />

        {patient && patient.has('_id') && patientRequiresCopay(patient, insuranceCompanies) && (
          <div className='vertical-margin'>
            <CopaidSessionsSection
              patient={patient}
              onAddSession={handleAddCopaidSession}
              onDeleteSession={handleDeleteCopaidSession}
            />
          </div>
        )}
        {patient && patient.has('_id') && (
          <AppointementList
            appointments={patientAppointments}
            patientId={patient && patient.get('_id')}
            dispatchRefreshPatient={dispatchRefreshPatient}
          />
        )}
        {patient && patient.has('_id') && (
          <BorderedArea title='Tratamientos' summary={`Total: ${patientTreatments.count()}`}>
            <TreatmentsList hideTitle treatments={patientTreatments} showPatientChip={false} />
          </BorderedArea>
        )}
        
      </DialogContent>
    </Dialog>
  )
}

PatientDialog.propTypes = {
  handleCloseDialog: PropTypes.func.isRequired,
  isDialogOpened: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  dispatchGetAppointmentsByPatient: PropTypes.func.isRequired,

  patient: ImmutablePropTypes.map,
  patientAppointments: ImmutablePropTypes.list,
  patientTreatments: ImmutablePropTypes.map,
}

const mapStateToProps = (state) => {
  const dialogData = dialogSelectors.getPatientDialogData(state)

  let patient = null
  let patientTreatments = null
  let patientAppointments = Immutable.List()
  if(dialogData && dialogData.has('patient')) {
    const dialogPatient = dialogData.get('patient')
    const patientId = dialogPatient.get('_id')
    const allPatients = patientSelectors.getAll(state)
    patient = allPatients && allPatients.has(patientId) ? allPatients.get(patientId) : dialogPatient

    const appointments = appointmentSelectors.getAll(state)
    if(appointments) {
      patientAppointments = appointments
        .filter(appointment => appointment.get('patient') === patientId)
    }

    patientTreatments = treatmentSelectors.getAllTreatmentsForPatient(state, patientId)
  }

  return { patient, patientAppointments, patientTreatments, insuranceCompanies: insuranceCompanySelectors.getAll(state) }
}

const mapDispatchToProps = dispatch => ({
  dispatchGetAppointmentsByPatient: (patientId) => dispatch(appointmentActions.getAllByPatient(patientId)),
  dipatchGetTreatmentsByPatient: (patientId) => dispatch(treatmentActions.getAllByPatient(patientId)),
  dispatchRemovePatient: id => dispatch(patientActions.remove(id)),
  dispatchUpdatePatient: patient => dispatch(patientActions.update(patient)),
  dispatchAddPatient: (data) => dispatch(patientActions.add(data)),
  dispatchRefreshPatient: (id) => dispatch(patientActions.refreshById(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PatientDialog)
